/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { MinMaxRuleResource } from './';
import {
    MinMaxRuleResourceFromJSON,
    MinMaxRuleResourceFromJSONTyped,
    MinMaxRuleResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface RuleResourcesInner
 */
export interface RuleResourcesInner {
    /**
     * 
     * @type {string}
     * @memberof RuleResourcesInner
     */
    name: RuleResourcesInnerNameEnum;
    /**
     * 
     * @type {MinMaxRuleResource}
     * @memberof RuleResourcesInner
     */
    minMaxRule: MinMaxRuleResource;
}


/**
 * @export
 */
export const RuleResourcesInnerNameEnum = {
    FunctionalSkills: 'FUNCTIONAL_SKILLS',
    GlobalSkills: 'GLOBAL_SKILLS',
    GlobalSkillsLength: 'GLOBAL_SKILLS_LENGTH',
    IndustryExpertises: 'INDUSTRY_EXPERTISES',
    ResumeDescriptionLength: 'RESUME_DESCRIPTION_LENGTH',
    Skills: 'SKILLS',
    SkillsWarning: 'SKILLS_WARNING',
    TopSkills: 'TOP_SKILLS',
    CertificationSkills: 'CERTIFICATION_SKILLS',
    HeadlineLength: 'HEADLINE_LENGTH',
    UsernameLength: 'USERNAME_LENGTH',
    OtherCategoryLength: 'OTHER_CATEGORY_LENGTH',
    CategoriesCount: 'CATEGORIES_COUNT',
    FamiliesCount: 'FAMILIES_COUNT',
    WorkExperienceDescriptionLength: 'WORK_EXPERIENCE_DESCRIPTION_LENGTH',
    WorkExperienceTitleLength: 'WORK_EXPERIENCE_TITLE_LENGTH',
    WorkExperienceClientCompanyLength: 'WORK_EXPERIENCE_CLIENT_COMPANY_LENGTH',
    WorkExperienceCount: 'WORK_EXPERIENCE_COUNT',
    SignupRegularSkillsCount: 'SIGNUP_REGULAR_SKILLS_COUNT',
    LanguagesCount: 'LANGUAGES_COUNT',
    EducationDegreeLength: 'EDUCATION_DEGREE_LENGTH',
    EducationSchoolLength: 'EDUCATION_SCHOOL_LENGTH',
    EducationGraduationYearRange: 'EDUCATION_GRADUATION_YEAR_RANGE',
    EducationCountStrategy: 'EDUCATION_COUNT_STRATEGY',
    DailyRatePrice: 'DAILY_RATE_PRICE'
} as const;
export type RuleResourcesInnerNameEnum = typeof RuleResourcesInnerNameEnum[keyof typeof RuleResourcesInnerNameEnum];


/**
 * Check if a given object implements the RuleResourcesInner interface.
 */
export function instanceOfRuleResourcesInner(value: object): value is RuleResourcesInner {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('minMaxRule' in value) || value['minMaxRule'] === undefined) return false;
    return true;
}

export function RuleResourcesInnerFromJSON(json: any): RuleResourcesInner {
    return RuleResourcesInnerFromJSONTyped(json, false);
}

export function RuleResourcesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleResourcesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'minMaxRule': MinMaxRuleResourceFromJSON(json['minMaxRule']),
    };
}

export function RuleResourcesInnerToJSON(value?: RuleResourcesInner | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'minMaxRule': MinMaxRuleResourceToJSON(value['minMaxRule']),
    };
}

